import * as React from 'react';

//MUI components
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
//MUI Icons
import PlaceIcon from '@mui/icons-material/Place';

//Redux tools and hooks
import { useSelector, useDispatch } from "react-redux";
import { idSpotSlice } from "../../../../store/idSpotSlice.js";
import { getIdSpot } from "../../../../store/selectors.js";

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)


// prop : array of objects (spots)
export default function BasicSelect({ listSpots }) { //components to select the rental spot
  const dispatch = useDispatch();
  const idSpot = useSelector(getIdSpot);
  const lang = useSelector(getLang) //global state : language

  const handleChange = (event) => {//when selected spot change
    dispatch(idSpotSlice.actions.setIdSpot(event.target.value)); //update global state

  };

  return (
    <Box sx={{ minWidth: 120, display: 'flex', alignItems: 'center' }} >
      <FormControl fullWidth >
        <InputLabel id="demo-simple-select-label">{translator("Point de retrait/retour des vélos :", lang, "spotSelectLabel")}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={idSpot > 0 ? idSpot : ''} //MUI select does not want a '0' value (but ok for '')
          label={translator("Point de retrait/retour des vélos :", lang, "spotSelectLabel")}
          onChange={handleChange}
        >
          {
            listSpots.map((spot) => <MenuItem key={spot.id_spot} value={+spot.id_spot}>{+spot.id_spot < 99 ? spot.nom_spot : translator("livraison", lang, "spotSelectItem")}</MenuItem>)
          }

        </Select>
      </FormControl>
    </Box>
  );
}